/* Los estados del pedido, en el idioma de la pantalla del cliente.
 *
 * Vienen en español de la tabla `estado_pedidos`, que es interna y la
 * comparte el admin. Renombrar esas filas cambiaria tambien lo que ve el
 * admin y lo que muestran los pedidos viejos, asi que la traduccion vive
 * en la pantalla.
 *
 * Esto estaba escrito dentro del modal de detalle, y el listado de atras
 * no lo usaba: el mismo pedido decia "Processing" adentro y "Pendiente"
 * afuera. Aca hay un solo lugar donde estan los cinco.
 */

const ESTADOS = {
  pendiente: "Pending",
  "en proceso": "Processing",
  "en ruta": "In transit",
  finalizado: "Completed",
  cancelado: "Cancelled",
};

/* Lo que no este en la lista se devuelve tal cual: es mejor mostrar el
   nombre en español que esconder un estado que alguien agrego despues. */
export const traducirEstadoPedido = (texto) => {
  const t = String(texto ?? "").trim();
  if (!t) return null;
  return ESTADOS[t.toLowerCase()] || t;
};

export default traducirEstadoPedido;
